import { jsx as s, jsxs as d } from "react/jsx-runtime";
import { c as t } from "./index-2QXL0WYc.js";
import { forwardRef as f } from "react";
import { GlobalCSSClass as r } from "./enums.js";
import { getFormControlValueAsStringIfDefined as l } from "./helpers/form/getFormControlValueAsStringIfDefined.js";
const v = "ids-select-v5150", S = "ids-select--wrapper-v5150", u = "ids-select--element-v5150", o = {
  select: v,
  wrapper: S,
  element: u
}, w = f(
  ({
    children: n,
    className: m,
    defaultValue: a,
    placeholder: e,
    value: c,
    ...i
  }, p) => /* @__PURE__ */ s(
    "div",
    {
      className: t(o.wrapper, r.FormElementInner),
      children: /* @__PURE__ */ d(
        "select",
        {
          ...i,
          className: t(
            o.element,
            m,
            r.FormElementInner
          ),
          defaultValue: l(a),
          ref: p,
          value: l(c),
          children: [
            e && /* @__PURE__ */ s("option", { value: "", children: e }),
            n
          ]
        }
      )
    }
  )
);
w.displayName = "SelectControl";
export {
  w as S,
  o as s
};
